<script>
  import {Line} from 'vue-chartjs'
  import chart_mixin from './chart'

  //Delete width and height props
  var CustomLine = Object.assign({}, Line);
  CustomLine.props = Object.assign({}, Line.props);
  delete CustomLine.props.width;
  delete CustomLine.props.height;

  export default {
    extends: CustomLine,
    mixins: [chart_mixin],
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/helpers/components/charts/LineChart.vue